<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M13.9807 8.20994C14.0156 7.93374 14.0335 7.65228 14.0335 7.36662C14.0335 3.68472 11.0488 0.699951 7.36686 0.699951C3.68496 0.699951 0.700195 3.68472 0.700195 7.36662C0.700195 11.0485 3.68496 14.0333 7.36686 14.0333C7.65713 14.0333 7.94307 14.0147 8.22355 13.9788M7.36686 3.36662V7.36662L9.85911 8.61274"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
